module.exports = __webpack_public_path__ + "static/img/celebration6.afe714b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/celebration6.jpg
// module id = 6D1n
// module chunks = 0